"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repoTreeUrl = exports.fetchTree = exports.decodeBase64ToUtf8 = exports.getFullTree = exports.getTree = void 0;

var _path = _interopRequireDefault(require("path"));

var _base = _interopRequireDefault(require("base-64"));

var _utf = _interopRequireDefault(require("utf8"));

var _ = require("../../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getTree = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var url, config, response, listing;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, config = _ref.config;
            _context.next = 3;
            return (0, _.get)({
              url: url,
              config: config
            });

          case 3:
            response = _context.sent;
            listing = response.tree;
            return _context.abrupt("return", listing);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTree(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getTree = getTree;

var getFullTree = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var owner, repository, sha, config, _ref3$recursive, recursive, _ref3$per_page, per_page, tree, moreData, page, options, data, _tree;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            owner = _ref3.owner, repository = _ref3.repository, sha = _ref3.sha, config = _ref3.config, _ref3$recursive = _ref3.recursive, recursive = _ref3$recursive === void 0 ? true : _ref3$recursive, _ref3$per_page = _ref3.per_page, per_page = _ref3$per_page === void 0 ? 10000 : _ref3$per_page;
            tree = [];
            moreData = true;
            page = 0;

          case 4:
            if (!moreData) {
              _context3.next = 15;
              break;
            }

            options = {
              recursive: recursive,
              per_page: per_page,
              page: page
            };
            _context3.next = 8;
            return fetchTree(_objectSpread({
              owner: owner,
              repository: repository,
              sha: sha,
              config: config
            }, options));

          case 8:
            data = _context3.sent;
            _tree = data.tree.map(function (blob) {
              var getBlob = /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var _blob, decoded;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return (0, _.get)({
                            url: blob.url,
                            config: config
                          });

                        case 2:
                          _blob = _context2.sent;
                          decoded = _blob.encoding === 'base64' ? decodeBase64ToUtf8(_blob.content) : undefined;
                          return _context2.abrupt("return", _objectSpread({}, _blob, {
                            decoded: decoded
                          }));

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function getBlob() {
                  return _ref5.apply(this, arguments);
                };
              }();

              return _objectSpread({}, blob, {
                getBlob: getBlob
              });
            });
            tree = tree.concat(_tree);
            moreData = data.truncated;

            if (moreData) {
              page++;
            }

            _context3.next = 4;
            break;

          case 15:
            return _context3.abrupt("return", tree);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getFullTree(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getFullTree = getFullTree;

var decodeBase64ToUtf8 = function decodeBase64ToUtf8(encoded) {
  var bytes = _base.default.decode(encoded);

  var text = _utf.default.decode(bytes);

  return text;
}; // http://bg.door43.org/api/v1/repos/unfoldingword/en_ugl/git/trees/master


exports.decodeBase64ToUtf8 = decodeBase64ToUtf8;

var fetchTree = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6) {
    var owner, repository, _ref6$sha, sha, per_page, page, recursive, config, params, url, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            owner = _ref6.owner, repository = _ref6.repository, _ref6$sha = _ref6.sha, sha = _ref6$sha === void 0 ? 'master' : _ref6$sha, per_page = _ref6.per_page, page = _ref6.page, recursive = _ref6.recursive, config = _ref6.config;
            params = {
              recursive: recursive,
              per_page: per_page,
              page: page
            };
            url = _path.default.join(_.apiPath, 'repos', owner, repository, 'git', 'trees', sha);
            _context4.next = 5;
            return (0, _.get)({
              url: url,
              params: params,
              config: config
            });

          case 5:
            data = _context4.sent;
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchTree(_x3) {
    return _ref7.apply(this, arguments);
  };
}(); // /api/v1/repos/unfoldingWord/en_ta/git/trees/master


exports.fetchTree = fetchTree;

var repoTreeUrl = function repoTreeUrl(_ref8) {
  var full_name = _ref8.full_name,
      _ref8$branch = _ref8.branch,
      branch = _ref8$branch === void 0 ? '' : _ref8$branch,
      _ref8$default_branch = _ref8.default_branch,
      default_branch = _ref8$default_branch === void 0 ? '' : _ref8$default_branch;

  var url = _path.default.join(_.apiPath, 'repos', full_name, 'git', 'trees', branch || default_branch);

  return url;
};

exports.repoTreeUrl = repoTreeUrl;